import React from 'react';

function ProjectsSection() {
  return (
    <section id="projects">
        <h2>My Projects</h2>
        <div className="projects-container">
            <div className="project-card">
                <h3>Interactive Photo Gallery</h3>
                <p>An engaging and dynamic photo gallery featuring seamless image filtering, smooth hover effects, and a responsive lightbox modal for immersive full-screen viewing. Built with HTML, CSS, and JavaScript to deliver an intuitive and visually captivating user experience</p>
                <a href="https://port.alvarezsm.com/" className="view-project-btn">View Project</a>
            </div>
            <div className="project-card">
                <h3>Weather App</h3>
                <p>A real-time weather application that fetches live data using an API. Features a user-friendly interface with location-based updates, detailed forecasts, and dynamic weather icons for an engaging experience. Built with HTML, CSS, and JavaScript.</p>
                <a href="https://port.alvarezsm.com/" className="view-project-btn">View Project</a>
            </div>
            <div className="project-card">
                <h3>Demostration Website</h3>
                <p>A feature-rich demo website showcasing IP and location identification, along with a secure webmail login system. Built with HTML, CSS, and JavaScript, it offers a responsive layout and an intuitive user experience for seamless interaction</p>
                <a href="https://test.alvarezsm.com/" className="view-project-btn">View Project</a>
            </div>
            <div className="project-card">
                <h3>CRUD To-Do List App</h3>
                <p>A fully interactive task management app with Create, Read, Update, and Delete functionality. Users can add, edit, and remove tasks effortlessly. Features real-time updates, local storage support, and a clean, responsive UI. Built with HTML, CSS, and JavaScript.</p>
                <a href="https://port.alvarezsm.com/" className="view-project-btn">View Project</a>
            </div>
            {/* Add more project cards here */}
        </div>
    </section>
  );
}

export default ProjectsSection;
